import { getValue } from "@utils/lodash";
import "./filter-form.scss";
// import AddFilterNew from "../AddFilterNew";
import InputField from "@_common/InputRuleFeild";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import ResetSvgComponent from "../../../assets/svg-components/reset";

export default function DashboardFilterForm(props: any) {
  const {
    //entity mapping
    headerList,
    headerLoading,
    levelObj,
    childEntityLoading,
    handleClickEntity,
    urlParams,
    handleChangeEntity,
  } = props;
  return (
    <div
      className={`filter-slidder-wrapper  ${
        props.filterIsOpen ? "filter-slidder-wrapper--active" : ""
      }`}
    >
      <div className="filter-form-wrappper w-100 active">
        <div className="filter-form-wrappper__container">
          {/* {getValue(props, `submitText`, "") ? null : (
            <div className="d-flex align-items-center justify-content-between my-3">
              <h6 className="filter-form-wrappper__title">Filter by DashboardFilterForm</h6>
              <img
                src="/images/close-black.svg"
                className="img-fluid cursor-pointer"
                onClick={props.setFilterFormVisibility}
              />
            </div>
          )} */}

          <div className="filter-header-wrapper d-flex align-items-center justify-content-between">
            <div className="filter-header-left-wrapper d-flex align-items-center">
              <div className="filter-close-wrapper">
                <img
                  src="/images/close-circle.svg"
                  className="img-fluid cursor-pointer"
                  onClick={props.handleFilter}
                />
              </div>
              <div className="filter-title-wrapper">
                <h6 className="filter-form-wrappper__title">Filter</h6>
              </div>

              <div className="filter-module-details-wrapper">
                <div className="filter-module-name">
                  {props.moduleName}
                </div>
                <div className="filter-submodule-name">{props.subModuleName}</div>
              </div>
            </div>

            <div className="filter-header-right-wrapper">
              <div className="filter-form-wrappper__cta-wrapper p-0 d-flex">
                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
                  onClick={props.reset}
                >
                  <div className="d-flex align-items-center mt--3">
                    <ResetSvgComponent size={24} color={"#5F6368"} /> Reset
                  </div>
                </button>

                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--cancel"
                  onClick={props.handleFilter}
                >
                  Cancel
                </button>

                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
                  onClick={props.handleSubmitSmartFilter}
                >
                  {getValue(props, `submitText`, "")
                    ? getValue(props, `submitText`, "")
                    : "Search"}
                </button>
              </div>
            </div>
          </div>

          <div className="filter-body-wrapper">
            <div className="filter-body-card">
              <div className="filter-card-title">Filter By</div>
              {headerLoading ? (
                <p className="text-center mt-2">Please wait...</p>
              ) : getValue(headerList, `length`, 0) > 0 ? (
                <div className="d-flex justify-content-between gap">
                  <div className="dashboard-self-compliance dashboard-content-holder">
                    {headerList.map((searchObj: object, index: number) => {
                      let selectedLevel =
                        getValue(searchObj, `group_level`, 0) > 0
                          ? getValue(
                              urlParams,
                              `level${parseInt(
                                getValue(searchObj, `group_level`, "")
                              )}`,
                              ""
                            )
                          : "";

                      let currentSelectedItem = selectedLevel.split("_")[0];
                      let selectedValue =
                        getValue(
                          levelObj,
                          `[${getValue(searchObj, `id`, "")}].length`,
                          0
                        ) > 0 &&
                        getValue(
                          levelObj,
                          `[${getValue(searchObj, `id`, "")}]`,
                          []
                        ).filter((item: any) =>
                          item.id == currentSelectedItem
                            ? parseInt(currentSelectedItem)
                            : null
                        );
                      return (
                        <>
                          <div
                            className={`cursor-pointer dashboard-fields-wrapper`}
                          >
                            <div
                              className="position-relative form-group  align-items-center cursor-pointer mb-0"
                              key={`location-${index}`}
                            >
                              <div className="dashboard-fields-label">
                                {getValue(searchObj, `group_name`, "")}
                              </div>
                              <div>
                                <div className="filter-form-wrappper__location-input">
                                  <SearchableDropdownSelect
                                    placeholder={`Choose ${getValue(
                                      searchObj,
                                      `group_name`,
                                      ""
                                    )}`}
                                    options={getValue(
                                      levelObj,
                                      `[${getValue(searchObj, `id`, "")}]`,
                                      []
                                    )}
                                    searchLoading={false}
                                    handleChange={(val: any) =>
                                      handleChangeEntity(
                                        val,
                                        getValue(searchObj, `id`, ""),
                                        getValue(searchObj, `group_level`, ""),
                                        index
                                      )
                                    }
                                    handleClick={(e: any) =>
                                      handleClickEntity(
                                        getValue(e, `id`, ""),
                                        getValue(searchObj, `id`, ""),
                                        getValue(searchObj, `group_level`, ""),
                                        index
                                      )
                                    }
                                    value={
                                      getValue(selectedValue, `length`, 0) > 0
                                        ? selectedValue[0]
                                        : ""
                                    }
                                    label="label"
                                    id="id"
                                    name={getValue(searchObj, `group_name`, "")}
                                    // removeClose
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <br /> */}
                        </>
                      );
                    })}
                  </div>
                  {/* </div> */}
                  {/* <div className="filter-form-wrappper__location flex-2"></div> */}
                  {/* <div className="filter-form-wrappper__location flex-2"></div> */}
                </div>
              ) : (
                <p className="text-center mt-2">No Entity Mapped</p>
              )}
            </div>
          </div>
        </div>
        <div className="filter-form-wrappper__cta-wrapper d-none">
          {getValue(props, `permissions`, []).includes("create") && (
            <button
              className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
              onClick={props.handleSubmitSmartFilter}
            >
              {getValue(props, `submitText`, "")
                ? getValue(props, `submitText`, "")
                : "Search"}
            </button>
          )}
          <button
            className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
            onClick={props.reset}
          >
            Reset
          </button>
        </div>

        {/* <AddFilterNew /> */}
      </div>
    </div>
  );
}
